/**
 * カスタムボタンの共通処理
 */
$(function () {
    /* ボタン式チェックボックス */
    $(document).on('click', '.check-button input', function() {
        let label = $(this).parent();
        $(label).toggleClass('active', $(this).prop('checked'));
    });
});